import "./Automation.module.css";
import Header from "@/reusable_sections/Header";
import OCortePerfeito from "./sections/OCortePerfeito";
import CoreExpertise from "./sections/CoreExpertise";
import ServiceCategories from "./sections/ServiceCategories";
import Footer from "@/reusable_sections/Footer";
export default function AutomationPage() {
  return <div className="w-full overflow-hidden">
      <Header />
      <main>
        <OCortePerfeito />
        <ServiceCategories />
        <CoreExpertise />
      </main>
      <Footer />
    </div>;
}